import React from 'react';

import HelpButton from 'help/HelpButton';
import {FloatingInteraction, FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import runModal from 'ui-library/runModal';

import ParameterInfoModal from './ParameterInfoModal';

interface ParameterInfoButtonProps {
  largeModal?: boolean;
}

export default function ParameterInfoButton({largeModal = false}: ParameterInfoButtonProps): JSX.Element {
  return (
    <HelpButton
      renderContent={() => (
        <div>
          When this setting is enabled, users can enter one or more values in this parameter. Queries must be
          written to allow for multiple values.{' '}
          <a
            onClick={async () => {
              await runModal(ParameterInfoModal, {large: largeModal});
            }}
          >
            Learn more
          </a>{' '}
          about how to configure parameters in your query.
        </div>
      )}
      iconClassName="u-mini-spacing-left"
      placement={FloatingPlacement.BOTTOM}
      interaction={FloatingInteraction.HOVER}
    />
  );
}
